import api from './api';

class OrganizationProfileService {
  static async getProfile() {
    const response = await api.get('/sourcing/org-profile');
    return response.data;
  }

  static async saveProfile(payload) {
    const response = await api.put('/sourcing/org-profile', payload);
    return response.data;
  }
}

export default OrganizationProfileService;
